const UNKNOWN_ERROR = 'unknown_error';
const USER_CANCELED = 'user_canceled';
const TIMEOUT = 'timeout';
const PARSE_ERROR = 'parse_error';
const NETWORK_OFFLINE = 'network_offline';
const NETWORK_RESET = 'network_reset';
const NETWORK_OTHER = 'network_other';
const NETWORK_OFFLINE_ERROR_CODES = new Set(['ENOTFOUND', 'EAI_AGAIN', 'EHOSTUNREACH', 'ENETUNREACH', 'ECONNREFUSED']);
const NETWORK_RESET_ERROR_CODES = new Set(['ECONNRESET']);
const NETWORK_OFFLINE_REASON_PATTERN = /INTERNET_DISCONNECTED|NAME_NOT_RESOLVED|CONNECTION_REFUSED/i;
const NETWORK_RESET_REASON_PATTERN = /interrupted|CONNECTION_RESET|ABORTED|NETWORK_CHANGED/i;
function getErrorCodeString(errorObj) {
    if (errorObj == null || typeof errorObj !== 'object') {
        return undefined;
    }
    const candidate = errorObj.code;
    return typeof candidate === 'string' ? candidate : undefined;
}
function deriveNetworkErrorCode(reason, errorObj) {
    const codeStr = getErrorCodeString(errorObj);
    if (codeStr) {
        if (NETWORK_OFFLINE_ERROR_CODES.has(codeStr)) {
            return NETWORK_OFFLINE;
        }
        if (NETWORK_RESET_ERROR_CODES.has(codeStr)) {
            return NETWORK_RESET;
        }
    }
    if (reason) {
        if (NETWORK_OFFLINE_REASON_PATTERN.test(reason)) {
            return NETWORK_OFFLINE;
        }
        if (NETWORK_RESET_REASON_PATTERN.test(reason)) {
            return NETWORK_RESET;
        }
    }
    return NETWORK_OTHER;
}
function deriveBizErrorCode(bizCode) {
    if (typeof bizCode === 'string') {
        return bizCode.length > 0 ? bizCode : UNKNOWN_ERROR;
    }
    if (typeof bizCode === 'number' && Number.isFinite(bizCode)) {
        return String(bizCode);
    }
    return UNKNOWN_ERROR;
}
function deriveHttpErrorCode(httpStatus) {
    if (typeof httpStatus === 'number' && Number.isFinite(httpStatus)) {
        return `http_${httpStatus}`;
    }
    return UNKNOWN_ERROR;
}
export function deriveCoreTrackErrorCode(input) {
    const { result, failType, bizCode, httpStatus, reason, errorObj } = input;
    if (result === 'success') {
        return undefined;
    }
    if (result === 'canceled') {
        return USER_CANCELED;
    }
    switch (failType) {
        case 'biz':
            return deriveBizErrorCode(bizCode);
        case 'http':
            return deriveHttpErrorCode(httpStatus);
        case 'timeout':
            return TIMEOUT;
        case 'network':
            return deriveNetworkErrorCode(reason, errorObj);
        case 'parse':
            return PARSE_ERROR;
        case 'unknown':
            return UNKNOWN_ERROR;
        default:
            return UNKNOWN_ERROR;
    }
}
